import React from 'react';
// import PropTypes from 'prop-types';

class NoMatchPage extends React.PureComponent {
  render () {
    return (
      <div>NoMatchPage</div>
    )
  }
}

export default NoMatchPage;



// WEBPACK FOOTER //
// ./src/pages/NoMatchPage/index.js